<template>
    <span v-if="$slots" class="dangerC"> ¥<slot></slot> </span>
</template>

<script>
export default {
    name: "RedPrice"
};
</script>



// WEBPACK FOOTER //
// src/components/RedPrice/index.vue